import utils from "@/stores/utils";
import axios from '@/plugins/axios';
import Decimal from 'decimal.js';

const state = {
    invoice: null,
    due_date: null,
    invoice_id: null,
    invoice_date: null,
    invoice_file: null,
    invoice_file_url: null,
    invoice_data: null,
    invoice_type: 'customerinvoice',

    settings: {},
    validating_invoice_errors: {},
    validating_invoice: false,
    parsing_invoice: false,
    parsing_invoice_errors: null,
    parsing_mismatch: false,
    amounts_mismatch: false,
    missing_totals: false,
    confirm_invoice_totals: false,

    billingaccount: null,
    billingaccount_loading: false,
};

const getters = {
};

function computeInvoiceTotalInclVat(invoice) {
    if (invoice.total_amount_excl_vat && invoice.total_vat_amount) {
        return (new Decimal(state.invoice['total_amount_excl_vat']).plus(new Decimal(state.invoice['total_vat_amount']))).toNumber();
    }

    return null;
}

const mutations = {

    updateInvoice(state, invoice) {
        state.invoice = invoice;
        state.invoice_data = null;
        state.invoice_file = null;
        state.invoice_id = invoice?.invoice_id;
        state.invoice_file_url = invoice?.invoice_file;
        state.invoice_date = invoice?.invoice_date;
        state.due_date = invoice?.due_date;

        state.parsing_invoice = false;
        state.confirm_invoice_totals = false;
        state.parsing_invoice_errors = null;
        state.parsing_mismatch = false;

        state.validating_invoice = false;
        state.validating_invoice_errors = {};
        state.parsing_mismatch = false;
        state.amounts_mismatch = false;
        state.missing_totals = false;
    },

    updateInvoiceType(state, invoice_type) {
        state.invoice_type = invoice_type;
    },

    updateInvoiceId(state, invoice_id) {
        state.invoice_id = invoice_id;
    },

    updateInvoiceDate(state, invoice_date) {
        state.invoice_date = invoice_date;
    },

    updateDueDate(state, due_date) {
        state.due_date = due_date;
    },


    updateValidatingInvoice(state, validating) {
        state.validating_invoice = validating;
    },

    updateValidatingInvoiceErrors(state, validating_invoice_errors) {
        state.validating_invoice_errors = validating_invoice_errors;
    },

    updateBillingAccountLoading(state, loading) {
        state.billingaccount_loading = loading;
    },

    updateBillingAccount(state, billingaccount) {
        state.billingaccount = billingaccount;
    },


    confirmInvoiceTotals(state, confirmed) {
        state.confirm_invoice_totals = confirmed;
    },

    updateInvoiceFile(state, invoice_file) {
        state.confirm_invoice_totals = false;
        state.invoice_data = null;
        state.amounts_mismatch = false;
        state.missing_totals = false;
        if (invoice_file) {
            state.invoice_file = invoice_file;
            state.invoice_file_url = URL.createObjectURL(invoice_file);
        } else {
            state.invoice_file = null;
            state.invoice_file_url = null;
        }
    },

    updateParsingInvoice(state, parsing_invoice) {
        state.parsing_invoice = parsing_invoice;
    },

    updateParsingInvoiceErrors(state, parsing_invoice_errors) {
        state.parsing_invoice_errors = parsing_invoice_errors;
    },

    updateInvoiceData(state, invoice_data) {
        let newinvoice = { ...state.invoice };
        newinvoice[invoice_data.key] = invoice_data.value;
        newinvoice.total_amount_incl_vat = computeInvoiceTotalInclVat(newinvoice);
        state.invoice = newinvoice;
    },

    forceUpdateInvoiceWithParsedData(state, parsed_data) {
        let new_invoice = { ...state.invoice };
        if (parsed_data.invoice_id) {
            new_invoice.invoice_id = parsed_data.invoice_id;
            state.invoice_id = state.invoice_data.invoice_id;
        }
        if (parsed_data.invoice_date) {
            new_invoice.invoice_date = parsed_data.invoice_date;
            state.invoice_date = state.invoice_data.invoice_date;
        }
        if (parsed_data.due_date) {
            new_invoice.due_date = parsed_data.due_date;
            state.due_date = state.invoice_data.due_date;
        }
        state.invoice = new_invoice;
    },

    updateInvoiceWithParsedData(state, invoice_data) {
        state.invoice_data = invoice_data;
        state.parsing_mismatch = false;
        state.amounts_mismatch = false;
        state.missing_totals = false;

        let newinvoice = { ...state.invoice };
        const totals = ['total_amount_excl_vat', 'total_vat_amount', 'total_amount_incl_vat'];
        for (const key of totals) {
            const value = invoice_data[key];
            const readable = value !== null && value !== undefined && value !== '' && Number.isFinite(Number(value));
            if (!readable) {
                state.missing_totals = true;
            } else if (state.invoice[key] !== null && state.invoice[key] !== undefined &&
                !new Decimal(value).toDecimalPlaces(2).equals(new Decimal(state.invoice[key]).toDecimalPlaces(2))) {
                state.amounts_mismatch = true;
            }
        }
        for (const key of ['invoice_id', 'invoice_date', 'due_date']) {
            if (invoice_data[key] && state.invoice[key] && invoice_data[key] !== state.invoice[key]) {
                state.parsing_mismatch = true;
            }
        }
        for (let key of ['invoice_id', 'invoice_date', 'due_date']) {
            if (invoice_data[key] && !state.invoice[key]) {
                newinvoice[key] = invoice_data[key];
                state[key] = invoice_data[key];
            }
        }
        state.invoice = newinvoice;
    },
};


const actions = {

    async fetchBillingAccount({ commit, dispatch, state, rootGetters }, params) {
        if (rootGetters['session/current_user_permissions'].indexOf("billing.view_billingaccount") === -1) {
            return;
        }
        if (!state.invoice.biller || !state.invoice.billingaccount) {
            return;
        }
        commit('updateBillingAccountLoading', true);
        try {
            const response = await axios.get(`/api/billingaccounts/${state.invoice.billingaccount}/`);
            commit('updateBillingAccount', response.data);
            return response.data;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            throw error;
        } finally {
            commit('updateBillingAccountLoading', false);
        }
    },


    async validateInvoice({ commit, state }) {
        if (!state.billingaccount.handle_invoices && (state.parsing_invoice ||
            ((state.amounts_mismatch || state.missing_totals) && !state.confirm_invoice_totals))) {
            throw new Error('Vérifiez les montants de la facture avant de valider.');
        }
        let url = `/api/customerinvoices/${state.invoice.id}/validate/`;
        if (this.is_customer_provider_invoice) {
            url = `/api/customerorders/${state.invoice.order}/invoices/${state.invoice.id}/validate/`;
        }

        let data = new FormData();
        let options = {};

        if (state.invoice_file) {
            options.headers = { 'Content-Type': 'multipart/form-data' };
            data.append('invoice_file', state.invoice_file);
        }
        if (!state.billingaccount.handle_invoices) {
            data.append('ocr_receipt', state.invoice_data?.ocr_receipt || '');
            data.append('confirm_invoice_totals', state.confirm_invoice_totals);
            data.append('invoice_date', state.invoice_date);
            data.append('invoice_id', state.invoice_id);
            if (!state.invoice?.credit) {
                data.append('due_date', state.due_date);
            }
        }

        try {
            commit('updateValidatingInvoice', true);
            return await axios.post(url, data, options);
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            if (error.details?.extracted_totals) {
                commit("updateInvoiceWithParsedData", error.details.extracted_totals);
            }
            commit("updateValidatingInvoiceErrors", error.details);
            throw error;
        } finally {
            commit("updateValidatingInvoice", false);
        }
    },

    async parseInvoiceFile({ commit, dispatch, state }, params) {
        commit("updateInvoiceFile", null);
        commit("updateParsingInvoice", true);
        let url = "/api/billing/parseinvoice/";
        try {
            let data = new FormData();
            data.append("invoice_file", params.invoice_file);
            let response = await axios.post(url, data);
            commit("updateInvoiceFile", params.invoice_file);
            commit("updateInvoiceWithParsedData", response.data);
            return { ...response.data, amounts_mismatch: state.amounts_mismatch, parsing_mismatch: state.parsing_mismatch, missing_totals: state.missing_totals };

        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateParsingInvoiceErrors", error.details);
            commit("updateParsingInvoice", false);
            throw error;
        } finally {
            commit("updateParsingInvoice", false);
        }
    },

    init({ commit, dispatch, state }, params) {
        commit('updateInvoice', params?.invoice);
        commit('updateInvoiceType', params?.invoice_type || 'customerinvoice');
        dispatch('fetchBillingAccount');
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
